<template>
  <div>
    <b-modal
      id="modal-login"
      hide-footer
      centered
      no-close-on-backdrop
      title="Salary"
    >
      <b-form-group
        label="Final Salary"
        invalid-feedback="Final Salary is required."
        ref="final_sal"
      >
        <b-form-input
          type="number"
          v-model="finalSalary"
          class="form-control"
          placeholder="Enter final salary"
        />
      </b-form-group>
      <b-row class="mt-2">
        <b-col class="d-flex justify-content-end">
          <b-button variant="success" :disabled="request" @click="saveFinal()">
            <b-spinner v-if="request" type="grow" small label="Loading..." />
            <span v-else class="align-middle">Save</span>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-row class="match-height" align-h="center">
      <b-col lg="7" md="9">
        <b-card class="">
          <b-row align-h="center">
            <!-- <b-col cols="4"> </b-col> -->
            <b-col class="ml-3" cols="4">
              <b-form-group
                class="text-center"
                ref="picture"
                label=" "
                label-for="name-input"
                invalid-feedback="Picture is required."
              >
                <b-media no-body ref="picture" class="staff-app-photo-upload">
                  <div
                    v-if="!profilePicturePreview && logoloading !== true"
                    class="staff-app-photo-frame"
                  >
                    <b-link @click="$refs.fileProfile.click()">
                      <b-img
                        ref="previewEl"
                        src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                        style="border-radius: 100px"
                        fluid
                        height="120px"
                        width="120px"
                      />
                    </b-link>
                  </div>

                  <div
                    v-else-if="!profilePicturePreview && logoloading === true"
                    class="staff-app-photo-frame"
                  >
                    <b-spinner variant="primary" type="grow" label="Spinning" />
                  </div>

                  <div
                    v-else
                    class="staff-app-photo-frame staff-app-photo-frame--loaded"
                  >
                    <img
                      class="rcorners2 staff-app-photo-img"
                      :src="profilePicturePreview"
                      alt="Staff photo"
                      referrerpolicy="no-referrer"
                      @error="onPicturePreviewError"
                      @click="
                        !disableFields &&
                          logoloading !== true &&
                          $refs.fileProfile.click()
                      "
                    />
                    <div
                      v-if="logoloading === true"
                      class="staff-app-photo-upload-overlay"
                    >
                      <b-spinner variant="primary" type="grow" />
                    </div>
                    <b-button
                      v-if="!disableFields && logoloading !== true"
                      class="staff-app-photo-delete-btn"
                      variant="danger"
                      @click.stop="deleteLogo()"
                    >
                      <feather-icon icon="Trash2Icon" size="16" />
                    </b-button>
                  </div>

                  <input
                    type="file"
                    id="fileProfile"
                    hidden
                    ref="fileProfile"
                    @change="selectlogo()"
                    accept="image/*"
                    :disabled="disableFields"
                  />
                </b-media>
              </b-form-group>
            </b-col>
            <!-- <b-col cols="4"> </b-col> -->
          </b-row>
          <!-- <h3 class="mt-1">Student Information</h3> -->
          <hr />
          <h5 v-if="isMyskoolIuss" class="text-primary font-weight-bold mb-1">
            Employee Details
            <feather-icon
              icon="HelpCircleIcon"
              size="16"
              class="ml-25 text-muted"
              v-b-tooltip.hover
              title="General applicant information — name, contact, address, etc."
            />
          </h5>

          <b-row>
            <b-col md="6">
              <b-form-group
                label="Name *"
                invalid-feedback="Staff name is required."
                label-class="font-weight-bold"
              >
                <b-form-input
                  placeholder="Enter name"
                  ref="name"
                  v-model.trim="myObj.staff.name"
                  :disabled="disableFields"
                  @focusout="CheckName()"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="Father name *"
                invalid-feedback="Father name is required"
                label-class="font-weight-bold"
              >
                <b-form-input
                  ref="fname"
                  placeholder="Enter father name"
                  v-model.trim="myObj.staff.father_name"
                  :disabled="disableFields"
                  @focusout="CheckFName()"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="Spouse name"
                invalid-feedback="Spouse name is required."
                ref="spouse"
              >
                <b-form-input
                  placeholder="Enter spouse name"
                  :disabled="disableFields"
                  v-model.trim="myObj.staff.spouse"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Gender *"
                invalid-feedback="Gender name is required."
                label-class="font-weight-bold"
                ref="gender"
              >
                <v-select
                  v-model="myObj.staff.gender"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="genders"
                  :clearable="false"
                  :disabled="disableFields"
                  placeholder="Select gender"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Date of Birth *"
                invalid-feedback="Date of Birth is required."
                label-class="font-weight-bold"
                ref="dob"
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.staff.date_of_birth"
                  class="form-control"
                  :disabled="disableFields"
                  placeholder="Select date of birth"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Contact *"
                invalid-feedback="Contact number is required"
                label-class="font-weight-bold"
              >
                <vue-tel-input
                  v-model="myObj.staff.contact_number"
                  :inputOptions="vueTelOptions"
                  :dropdownOptions="dropOptions"
                  :defaultCountry="$store.state.countryCode"
                  @input="CheckSContact"
                  :disabled="disableFields"
                ></vue-tel-input>
                <small class="mr-1 text-danger" v-if="sPhoneerror"
                  >Phone number is required</small
                >
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="!isMyskoolIuss">
              <b-form-group
                label="Qualification *"
                invalid-feedback="qualification is required."
                label-class="font-weight-bold"
                ref="qua"
              >
                <v-select
                  v-model="myObj.staff.qualification"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="qualificationOptions"
                  :clearable="true"
                  :disabled="disableFields"
                  placeholder="Select qualification"
                  @input="CheckQualification()"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Designation *"
                invalid-feedback="designation is required."
                label-class="font-weight-bold"
                ref="design"
                v-if="showDesignationField"
              >
                <v-select
                  v-model="myObj.staff.designation"
                  :options="designationOptions"
                  :reduce="(opt) => opt.name"
                  label="name"
                  :clearable="false"
                  :disabled="disableFields || !myObj.staff.departmentID"
                  placeholder="Select designation"
                  @input="setDesignation()"
                />
              </b-form-group>
              <b-form-group
                label="Designation *"
                invalid-feedback="designation is required."
                label-class="font-weight-bold"
                ref="design"
                v-if="!showDesignationField"
              >
                <b-form-input
                  placeholder="Enter designation"
                  v-model.trim="myObj.staff.designation"
                  :disabled="disableFields"
                  @input="CheckDesignation()"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="!isMyskoolIuss">
              <b-form-group label="Stream" label-class="font-weight-bold">
                <v-select
                  v-model="myObj.staff.streamID"
                  :options="streamOptions"
                  :reduce="(opt) => opt.id"
                  label="name"
                  :clearable="true"
                  :disabled="disableFields"
                  placeholder="Select stream"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Experience"
                invalid-feedback="Experience is required."
              >
                <b-form-input
                  placeholder="Enter experience"
                  v-model.trim="myObj.staff.experience"
                  :disabled="disableFields"
                />
              </b-form-group>
            </b-col>
            <template v-if="showCampusField">
              <b-col md="6">
                <b-form-group
                  invalid-feedback="Campus is required."
                  label-class="font-weight-bold"
                  ref="camp"
                >
                  <template #label>
                    <span
                      v-if="isMyskoolIuss"
                      class="d-inline-flex align-items-center font-weight-bold"
                    >
                      Campus *
                      <feather-icon
                        icon="HelpCircleIcon"
                        size="14"
                        class="ml-25 text-muted"
                        v-b-tooltip.hover
                        title="Select the campus you are applying to."
                      />
                    </span>
                    <span v-else class="font-weight-bold">Campus *</span>
                  </template>
                  <v-select
                    v-model="myObj.staff.campusID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="campuses"
                    :clearable="false"
                    :reduce="(val) => val.id"
                    label="branch"
                    placeholder="Select campus"
                    :disabled="disableFields"
                    @input="setData()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-class="font-weight-bold"
                  invalid-feedback="Department is required."
                  ref="dep"
                >
                  <template #label>
                    <span
                      v-if="isMyskoolIuss"
                      class="d-inline-flex align-items-center font-weight-bold"
                    >
                      Department *
                      <feather-icon
                        icon="HelpCircleIcon"
                        size="14"
                        class="ml-25 text-muted"
                        v-b-tooltip.hover
                        title="Department where staff is needed."
                      />
                    </span>
                    <span v-else class="font-weight-bold">Department *</span>
                  </template>
                  <v-select
                    v-model="myObj.staff.departmentID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="departments"
                    :clearable="false"
                    :reduce="(val) => val.id"
                    label="name"
                    :disabled="depLoading || disableFields"
                    placeholder="Select department"
                    @input="onDepartmentChange()"
                  />
                </b-form-group>
              </b-col>
            </template>
          </b-row>
          <template v-if="isMyskoolIuss">
            <b-row class="iuss-entry-section">
              <b-col md="12">
                <div
                  class="d-flex align-items-center justify-content-between mb-50"
                >
                  <h5 class="mb-0 font-weight-bold">
                    Qualifications *
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Add each degree or qualification separately."
                    />
                  </h5>
                  <b-button
                    v-if="!disableFields"
                    variant="primary"
                    class="btn-icon rounded-circle iuss-entry-add-btn"
                    v-b-tooltip.hover
                    title="Add qualification"
                    @click="addQualification()"
                  >
                    <feather-icon icon="PlusIcon" size="18" />
                  </b-button>
                </div>

                <b-row
                  class="iuss-entry-head d-none d-md-flex text-muted small font-weight-bold mb-25 mx-0"
                >
                  <b-col md="3" class="px-50">Degree *</b-col>
                  <b-col md="2" class="px-50">Subject</b-col>
                  <b-col md="2" class="px-50">Institute</b-col>
                  <b-col md="2" class="px-50">Year</b-col>
                  <b-col md="2" class="px-50">Grade</b-col>
                  <b-col md="1" class="px-50"></b-col>
                </b-row>

                <div
                  v-for="(qual, qIndex) in qualifications"
                  :key="'qual-' + qIndex"
                  class="iuss-entry-row"
                >
                  <b-row class="iuss-entry-row-inner mx-0">
                    <b-col cols="12" md="3" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Degree *"
                        label-class="font-weight-bold d-md-none mb-50"
                        :invalid-feedback="
                          qIndex === 0 ? 'Qualification is required.' : ''
                        "
                        :ref="qIndex === 0 ? 'qua' : undefined"
                      >
                        <div class="iuss-entry-select-wrap">
                          <v-select
                            v-model="qual.degree"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="qualificationOptions"
                            :clearable="false"
                            :disabled="disableFields || dataloading"
                            placeholder="Select degree"
                            @input="CheckQualification()"
                          />
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Subject"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter subject"
                          v-model.trim="qual.subject"
                          :disabled="disableFields"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Institute"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter institute"
                          v-model.trim="qual.institute"
                          :disabled="disableFields"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      :cols="qualifications.length > 1 ? 5 : 6"
                      md="2"
                      class="px-50"
                    >
                      <b-form-group
                        class="iuss-entry-field"
                        label="Year"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter year"
                          v-model.trim="qual.year"
                          :disabled="disableFields"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      :cols="qualifications.length > 1 ? 5 : 6"
                      md="2"
                      class="px-50"
                    >
                      <b-form-group
                        class="iuss-entry-field"
                        label="Grade"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter grade"
                          v-model.trim="qual.grade"
                          :disabled="disableFields"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="2"
                      md="1"
                      class="px-50 iuss-entry-actions"
                      v-if="!disableFields && qualifications.length > 1"
                    >
                      <b-button
                        variant="outline-danger"
                        class="btn-icon rounded-circle iuss-entry-remove-btn"
                        v-b-tooltip.hover
                        title="Remove qualification"
                        @click="removeQualification(qIndex)"
                      >
                        <feather-icon icon="Trash2Icon" size="16" />
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <b-row class="iuss-entry-section mt-1">
              <b-col md="12">
                <div
                  class="d-flex align-items-center justify-content-between mb-50"
                >
                  <h5 class="mb-0 font-weight-bold">
                    Certificates
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Optional — add professional or training certificates."
                    />
                  </h5>
                  <b-button
                    v-if="!disableFields"
                    variant="primary"
                    class="btn-icon rounded-circle iuss-entry-add-btn"
                    v-b-tooltip.hover
                    title="Add certificate"
                    @click="addCertificate()"
                  >
                    <feather-icon icon="PlusIcon" size="18" />
                  </b-button>
                </div>

                <b-row
                  v-if="certificates.length"
                  class="iuss-entry-head d-none d-md-flex text-muted small font-weight-bold mb-25 mx-0"
                >
                  <b-col md="4" class="px-50">Certificate</b-col>
                  <b-col md="4" class="px-50">Institute</b-col>
                  <b-col md="2" class="px-50">Year</b-col>
                  <b-col md="2" class="px-50"></b-col>
                </b-row>

                <div
                  v-for="(cert, cIndex) in certificates"
                  :key="'cert-' + cIndex"
                  class="iuss-entry-row"
                >
                  <b-row class="iuss-entry-row-inner mx-0">
                    <b-col cols="12" md="4" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Certificate"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter certificate name"
                          v-model.trim="cert.name"
                          :disabled="disableFields"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Institute"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter institute"
                          v-model.trim="cert.institute"
                          :disabled="disableFields"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="10" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Year"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter year"
                          v-model.trim="cert.year"
                          :disabled="disableFields"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="2"
                      md="2"
                      class="px-50 iuss-entry-actions"
                      v-if="!disableFields"
                    >
                      <b-button
                        variant="outline-danger"
                        class="btn-icon rounded-circle iuss-entry-remove-btn"
                        v-b-tooltip.hover
                        title="Remove certificate"
                        @click="removeCertificate(cIndex)"
                      >
                        <feather-icon icon="Trash2Icon" size="16" />
                      </b-button>
                    </b-col>
                  </b-row>
                </div>

                <p v-if="!certificates.length" class="text-muted small mb-0">
                  No certificates added yet.
                </p>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Teaching Level"
                invalid-feedback="Teaching Level is required."
              >
                <v-select
                  v-if="isMyskoolIuss"
                  v-model="myObj.staff.teachingLevel"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="iussTeachingLevelOptions"
                  :clearable="true"
                  :disabled="disableFields"
                  placeholder="Select teaching level"
                />
                <b-form-input
                  v-else
                  placeholder="Enter teaching level"
                  v-model.trim="myObj.staff.teachingLevel"
                  :disabled="disableFields"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="CNIC *"
                invalid-feedback="CNIC is required."
                label-class="font-weight-bold"
                ref="cnic"
              >
                <b-form-input
                  placeholder="Enter CNIC"
                  v-model.trim="myObj.staff.cnic"
                  :disabled="disableFields"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Applied on *"
                invalid-feedback="Applied on is required."
                label-class="font-weight-bold"
                ref="reg_date"
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.staff.registrationDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  :disabled="disableFields"
                />
              </b-form-group>
            </b-col>
            <template v-if="reportDomain == 'myskoolhpgs'">
              <b-col md="6">
                <b-form-group
                  label="Demo at Campus"
                  invalid-feedback="Campus is required."
                  ref="demo_camp"
                >
                  <v-select
                    v-model="myObj.staff.demoCampusID"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="campuses"
                    :clearable="false"
                    :reduce="(val) => val.id"
                    label="branch"
                    placeholder="Select campus"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Pay Mode"
                  invalid-feedback="Pay mode is required."
                >
                  <v-select
                    v-model="myObj.staff.payMode"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="payOptions"
                    placeholder="Select pay mode"
                  />
                </b-form-group>
              </b-col>
            </template>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form-group
                label="Current Address *"
                invalid-feedback="Address is required."
                label-class="font-weight-bold"
                ref="address"
              >
                <b-form-input
                  placeholder="Enter current address"
                  v-model.trim="myObj.staff.address_current"
                  :disabled="disableFields"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Permanent Address"
                invalid-feedback="Address is required."
              >
                <b-form-input
                  placeholder="Enter permanent address"
                  v-model.trim="myObj.staff.address_permanent"
                  :disabled="disableFields"
                />
              </b-form-group>
            </b-col>
            <template v-if="isMyskoolOrIuss">
              <b-col md="6">
                <b-form-group label="Province" label-class="font-weight-bold">
                  <v-select
                    v-model="myObj.staff.province"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pakistanProvinces"
                    :clearable="true"
                    :disabled="disableFields"
                    placeholder="Select province"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="City" label-class="font-weight-bold">
                  <b-form-input
                    v-model.trim="myObj.staff.city"
                    :disabled="disableFields"
                    placeholder="Enter city"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="LinkedIn Profile"
                  label-class="font-weight-bold"
                >
                  <b-form-input
                    v-model.trim="myObj.staff.linkedinProfile"
                    :disabled="disableFields"
                    placeholder="https://linkedin.com/in/username"
                  />
                </b-form-group>
              </b-col>
            </template>
            <b-col md="12">
              <b-form-group
                label="Teaching Subjects"
                invalid-feedback="Subjects are required."
                ref="sub"
              >
                <v-select
                  v-model="myObj.subjectIDs"
                  multiple
                  :closeOnSelect="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="subjects"
                  :reduce="(opt) => opt.id"
                  label="subject"
                  :clearable="false"
                  input-id="categoryId"
                  ref="sub"
                  :disabled="dataloading || disableFields"
                  placeholder="Select teaching subjects"
                />
              </b-form-group>
            </b-col>
            <b-col :md="isMyskoolOrIuss ? 6 : 4">
              <b-form-group
                :invalid-feedback="'Availability is required.'"
                label-class="font-weight-bold"
                ref="avail"
              >
                <template #label>
                  <span
                    class="d-inline-flex align-items-center font-weight-bold"
                  >
                    Availability<span v-if="isMyskoolIuss"> *</span>
                    <feather-icon
                      v-if="isMyskoolIuss"
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Indicate when you can join — immediately or within a few days."
                    />
                  </span>
                </template>
                <v-select
                  v-model="myObj.staff.availibility"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="
                    isMyskoolIuss ? iussAvailabilityOptions : availibility
                  "
                  :clearable="false"
                  input-id="categoryId"
                  :disabled="disableFields"
                  placeholder="Select availability"
                  @input="CheckAvailability()"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="isMyskoolOrIuss">
              <b-form-group
                invalid-feedback="Last salary drawn is required."
                label-class="font-weight-bold"
                ref="prevSalary"
              >
                <template #label>
                  <span
                    class="d-inline-flex align-items-center font-weight-bold"
                  >
                    Last Salary Drawn<span v-if="isMyskoolIuss"> *</span>
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Enter your previous / last drawn salary amount."
                    />
                  </span>
                </template>
                <b-form-input
                  type="number"
                  v-model="myObj.staff.previousSalary"
                  class="form-control"
                  :disabled="disableFields"
                  placeholder="Enter last salary drawn"
                  @focusout="CheckPreviousSalary()"
                />
              </b-form-group>
            </b-col>
            <b-col :md="isMyskoolOrIuss ? 6 : 4">
              <b-form-group
                label="Expected Salary *"
                invalid-feedback="Expected salary is required."
                label-class="font-weight-bold"
              >
                <b-form-input
                  ref="salary"
                  type="number"
                  v-model="myObj.staff.expectedSalary"
                  class="form-control"
                  :disabled="disableFields"
                  placeholder="Enter expected salary"
                />
              </b-form-group>
            </b-col>
            <b-col :md="isMyskoolOrIuss ? 6 : 4">
              <b-form-group
                label="Appointed on"
                invalid-feedback="Appointment date is required"
                ref="appoint_date"
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.staff.appointedOn"
                  class="form-control"
                  :disabled="disableFields"
                  placeholder="Select appointment date"
                />
              </b-form-group>
            </b-col>
            <template v-if="isMyskoolOrIuss">
              <b-col md="6" class="mt-1">
                <b-form-group
                  label="Upload Salary Slip"
                  label-class="font-weight-bold"
                >
                  <b-button
                    variant="outline-primary"
                    block
                    :disabled="salarySlipLoading || disableFields"
                    @click="$refs.salarySlipInput.click()"
                  >
                    <b-spinner
                      v-if="salarySlipLoading"
                      type="grow"
                      small
                      label="Loading..."
                    />
                    <span v-else>
                      {{
                        myObj.staff.salarySlip ? "Replace Salary Slip" : "Upload Salary Slip"
                      }}
                    </span>
                  </b-button>
                  <input
                    ref="salarySlipInput"
                    type="file"
                    hidden
                    accept="image/*,.pdf"
                    :disabled="salarySlipLoading || disableFields"
                    @change="uploadSalarySlip()"
                  />
                  <div
                    v-if="myObj.staff.salarySlip"
                    class="d-flex align-items-center mt-50"
                  >
                    <a
                      :href="getDocOpenUrl(myObj.staff.salarySlip)"
                      target="_blank"
                      class="d-flex align-items-center mr-1"
                    >
                      <div class="file-type">
                        {{ getDocumentTypeLabel(myObj.staff.salarySlip) }}
                      </div>
                      <span class="ml-50 text-primary">View salary slip</span>
                    </a>
                    <feather-icon
                      v-if="!disableFields"
                      icon="Trash2Icon"
                      size="18"
                      class="text-danger cursor-pointer"
                      @click="removeSalarySlip()"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6" class="mt-1">
                <b-form-group label="Upload CV" label-class="font-weight-bold">
                  <b-button
                    variant="outline-primary"
                    block
                    :disabled="cvLoading || disableFields"
                    @click="$refs.cvFileInput.click()"
                  >
                    <b-spinner
                      v-if="cvLoading"
                      type="grow"
                      small
                      label="Loading..."
                    />
                    <span v-else>
                      {{ myObj.staff.cv ? "Replace CV" : "Upload CV" }}
                    </span>
                  </b-button>
                  <input
                    ref="cvFileInput"
                    type="file"
                    hidden
                    accept="image/*,.pdf,.doc,.docx"
                    :disabled="cvLoading || disableFields"
                    @change="uploadStaffCv()"
                  />
                  <div
                    v-if="myObj.staff.cv"
                    class="d-flex align-items-center mt-50"
                  >
                    <a
                      :href="getDocOpenUrl(myObj.staff.cv)"
                      target="_blank"
                      class="d-flex align-items-center mr-1"
                    >
                      <div class="file-type">
                        {{ getDocumentTypeLabel(myObj.staff.cv) }}
                      </div>
                      <span class="ml-50 text-primary">View CV</span>
                    </a>
                    <feather-icon
                      v-if="!disableFields"
                      icon="Trash2Icon"
                      size="18"
                      class="text-danger cursor-pointer"
                      @click="removeStaffCv()"
                    />
                  </div>
                </b-form-group>
              </b-col>
            </template>
            <b-col md="12" class="mt-2">
              <div class="file-uploader">
                <h5>
                  <b-spinner
                    variant="dark"
                    label="Spinning"
                    v-if="uploading"
                  ></b-spinner>
                  <span v-else> Upload Documents </span>
                </h5>
                <input
                  ref="cvDoc"
                  type="file"
                  class="file_upload"
                  @change="uploadDocument()"
                  multiple="true"
                  :disabled="uploading || disableFields"
                />
              </div>
            </b-col>
            <b-col md="12" class="mt-1">
              <div
                v-for="(entry, index) in documentEntries"
                :key="'staff-app-doc-' + index"
                class="file"
              >
                <a
                  :href="getDocOpenUrl(entry.url)"
                  target="_blank"
                  style="
                    display: flex;
                    align-items: center;
                    min-width: 0;
                    flex: 1;
                  "
                >
                  <img
                    v-if="isImageDoc(entry.url)"
                    :src="getDocPreviewUrl(entry.url)"
                    class="doc-list-thumb"
                    alt="Document preview"
                    referrerpolicy="no-referrer"
                    @error="onDocPreviewError($event, entry.url)"
                  />
                  <div v-else class="file-type">
                    {{ entry.typeLabel }}
                  </div>
                  <p class="file-name" :title="entry.name">{{ entry.name }}</p>
                </a>
                <div class="file-delete" v-if="!disableFields">
                  <i
                    class="fa fa-trash"
                    aria-hidden="true"
                    @click="deleteDocument(index)"
                  ></i>
                </div>
              </div>
            </b-col>
          </b-row>
          <!-- <b-row class="mt-1">
            <b-col md="6">
              <b-form-group
                label="Upload CV"
                invalid-feedback="CV is required"
                ref="docs"
              >
                <b-button
                  ref="docs"
                  @click="$refs.cvDoc.click()"
                  variant="primary"
                  :disabled="request || docLoading"
                  block
                >
                  <b-spinner
                    v-if="docLoading"
                    type="grow"
                    small
                    label="Loading..."
                  />
                  <span v-else>Upload</span>
                </b-button>
                <input
                  type="file"
                  id="cvDoc"
                  hidden
                  ref="cvDoc"
                  @change="addCV()"
                  accept="image/*,.pdf"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              v-if="mediaLoaded"
              style="display: flex; align-items: center"
            >
              <a :href="myObj.cv" target="_blank">
                <div class="file-type cursor-pointer">
                  {{ myObj.cv.split(".").pop().toUpperCase() }}
                </div>
              </a>
              <feather-icon
                icon="Trash2Icon"
                size="22"
                class="text-danger cursor-pointer"
                @click="removeCV()"
              />
            </b-col>
          </b-row> -->
        </b-card>

        <template
          v-if="reportDomain == 'myskoolhpgs' ? rights.interviewInfo : true"
        >
          <template v-for="(item, ind) in interObj">
            <b-card>
              <h4 class="d-flex align-items-center justify-content-between">
                Interview Information
                <b-button
                  v-if="item.interviews.id == 0"
                  @click="removeValue(item.interviews.id, ind)"
                  variant="outline-danger"
                  class="btn-icon"
                  pill
                  v-b-tooltip.hover.top
                  title="Remove"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </h4>
              <hr />
              <!-- <feather-icon
                  size="22"
                  icon="SettingsIcon"
                  class="cursor-pointer"
                  @click="openEval()"
                  v-b-tooltip.hover.top
                  title="Manage Evaluation"
                /> -->
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Date"
                    invalid-feedback="Date is required"
                  >
                    <flat-pickr
                      :config="config"
                      v-model="item.interviews.date"
                      class="form-control"
                      :placeholder="$t('Select Date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Status"
                    invalid-feedback="Status is required."
                  >
                    <v-select
                      v-model="item.interviews.status"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :clearable="false"
                      :options="statusOptions"
                      :reduce="(opt) => opt.value"
                      label="text"
                      placeholder="Select status"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Interview By"
                    invalid-feedback="Interview By is required."
                  >
                    <b-form-input
                      v-model.trim="item.interviews.interviewedBy"
                      class="form-control"
                      placeholder="Enter name"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Recommended Salary"
                    invalid-feedback="Salary is required."
                  >
                    <b-form-input
                      type="number"
                      v-model="item.interviews.recommendedSalary"
                      class="form-control"
                      placeholder="Enter salary"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Note"
                    invalid-feedback="Note is required."
                  >
                    <b-form-textarea
                      placeholder="Enter note"
                      rows="3"
                      v-model="item.interviews.note"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  class="d-flex align-items-center justify-content-between mb-1"
                >
                  <label class="bv-no-focus-ring col-form-label p-0"
                    >Include Evaluation</label
                  >
                  <b-form-checkbox
                    v-model="item.interviews.includeEvaluation"
                    switch
                    @change="(e) => checkEval(e, item)"
                  />
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Duration"
                    invalid-feedback="Salary is required."
                  >
                    <b-form-input
                      v-model="item.interviews.duration"
                      class="form-control"
                      placeholder="Enter duration"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  md="12"
                  v-if="
                    item.interviews.includeEvaluation &&
                    item.evaluationData.length > 0
                  "
                >
                  <b-row
                    v-for="(ev, index) in item.evaluationData"
                    :key="index"
                    class="mb-1"
                  >
                    <b-col md="12">
                      <h5 class="font-weight-bold mb-50">
                        {{ ev.meta_question }}
                      </h5>
                    </b-col>
                    <b-col md="12">
                      <b-button
                        v-for="(rt, i) in evalResp"
                        :key="i"
                        pill
                        class="btn-icon mr-50 mb-50"
                        size="sm"
                        :variant="
                          ev.responseID == rt.id ? 'success' : 'outline-success'
                        "
                        @click="ev.responseID = rt.id"
                      >
                        {{ rt.title }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>

            <!-- <b-row>
              <b-col md="12" class="text-center">
                <b-button
                  v-if="ind == interObj.length - 1"
                  @click="AddValue()"
                  variant="primary"
                  class="btn-icon"
                  pill
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
                
              </b-col>
            </b-row> -->
          </template>

          <b-card>
            <b-row>
              <b-col md="12" class="text-center">
                <b-button
                  @click="AddValue()"
                  variant="primary"
                  class="btn-icon"
                  pill
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
                <p class="mb-0 mt-50">Add Interview Information</p>
              </b-col>
            </b-row>
          </b-card>
        </template>

        <b-card v-if="reportDomain == 'myskoolhpgs' ? rights.approve : true">
          <h4>Approval</h4>
          <hr />
          <b-row>
            <b-col
              v-if="false"
              md="12"
              v-for="(item, ind) in approveObj"
              :key="ind"
            >
              <span>{{ ind + 1 }} - </span>
              <b-badge variant="light-success" class="mb-50">
                {{ item.id == 0 ? item.name : approvedBy_Meta }}
              </b-badge>
            </b-col>
            <!-- <b-col md="12" class="text-center">
              <b-button @click="approve()" variant="primary" class="btn-icon">
                Approve By Me
              </b-button>
            </b-col> -->
            <b-col md="4">
              <b-form-group
                label="Final Salary"
                invalid-feedback="Final Salary is required."
                ref="final_sal"
              >
                <b-form-input
                  type="number"
                  v-model="finalSalary"
                  class="form-control"
                  placeholder="Enter final salary"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Approval Date"
                invalid-feedback="Approval Date is required."
                ref="approve_date"
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.staff.approvalDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-button
                variant="primary"
                class="btn-icon mt-2"
                @click="formSubmitted('approve')"
                block
                :disabled="request"
              >
                Approve
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-button
          @click="formSubmitted('')"
          variant="success"
          :disabled="request || uploading"
          block
        >
          <b-spinner v-if="request" type="grow" small label="Loading..." />
          <span v-else>Submit</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import {
  getDocumentDisplayName,
  getDocumentTypeLabel,
  getUploadPath,
  uploadToMySkool,
  getMediaPreviewUrl,
  handleDrivePreviewError,
  isImageUrl,
} from "@/utils/gdriveUpload";
import {
  buildStreamOptions,
  normalizeStreamIdForUi,
  streamIdForApi,
} from "./streamUtils";
import vue2Dropzone from "vue2-dropzone";

import "vue2-dropzone/dist/vue2Dropzone.min.css";

const DEFAULT_QUALIFICATION_OPTIONS = [
  "Under Matric",
  "Matric",
  "Intermediate",
  "Bachelors",
  "Masters",
  "M.Phil",
  "PhD",
  "Diploma",
  "Certification",
  "Other",
];

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BButton,
  BMediaAside,
  BImg,
  BMedia,
  BLink,
  BSpinner,
  BBadge,
  BFormFile,
  BFormTextarea,
  BTable,
  BFormCheckbox,
  VBTooltip,
} from "bootstrap-vue";
import { resolve } from "path";
import { reject } from "q";
export default {
  components: {
    vueDropzone: vue2Dropzone,
    // DropZone,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    flatPickr,
    BCard,
    BButton,
    BMediaAside,
    BImg,
    BMedia,
    BLink,
    BSpinner,
    BBadge,
    BFormFile,
    BTable,
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      file: [],
      documentEntries: [],
      uploading: false,
      request: false,
      plus: "",
      logoloading: false,
      netAmount: 0,
      dataloading: false,
      admittedSections: [],
      currentSections: [],
      classes: [],
      genders: ["Male", "Female"],
      availibility: [
        "Part Time",
        "Full Time",
        "Probation",
        "Permanent",
        "Contractual",
        "Visiting",
        "Intern",
      ],
      iussAvailabilityOptions: [
        "Immediately",
        "Within a few days",
        "Within 1 week",
        "Within 2 weeks",
      ],
      iussTeachingLevelOptions: [
        "Grade Pre Nursery to KG",
        "I till III",
        "IV till VI",
        "VII to VIII",
        "O-Level",
        "AKU-EB",
        "Matriculation",
      ],
      groups: ["A", "B", "O", "AB"],
      religions: ["Islam", "Christianity", "Hinduism", "Buddhists"],
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      myObj: {
        staff: {
          id: 0,
          rfID: "",
          name: "",
          father_name: "",
          designation: "",
          gender: "",
          picture: "",
          date_of_birth: null,
          address_current: "",
          address_permanent: "",
          province: "",
          city: "",
          linkedinProfile: "",
          salarySlip: "",
          cv: "",
          contact_number: "",
          emergency_contact_person: "",
          emergency_contact_relation: "",
          emergency_number: "",
          qualification: "",
          certificate: "",
          note: "",
          experience: "",
          campusID: this.$store.state.userData.cId,
          status: "applicant",
          documents: "",
          availibility: "",
          expectedSalary: 0,
          previousSalary: 0,
          departmentID: 0,
          cnic: "",
          teachingLevel: "",
          applicantStatus: "pending",
          registrationDate: new Date().toJSON(),
          appointedOn: null,
          approvalDate: null,
          leaves_allowed_from: null,
          basicSalary: 0,
          totalSalary: 0,
          demoCampusID: 0,
          empCode: 0,
          spouse: "",
          payMode: null,
          accountTitle: null,
          accountNumber: null,
          tag: "Physical",
          streamID: 0,
        },
        subjectIDs: [],
      },
      finalSalary: 0,
      classObj: {
        class_admitted: null,
        section_admitted: null,
        subject_admitted: null,
      },
      fields: [
        { label: "Class", key: "class_admitted" },
        { label: "section", key: "section_admitted" },
        { label: "subject", key: "subject_admitted" },
      ],
      // for newTeachingList
      // fields2: [
      //   { label: "Class", key: "className" },
      //   { label: "section", key: "sectionName" },
      //   { label: "subject", key: "subjects" },
      //   "actions",
      // ],
      fields2: [
        { label: "Class", key: "cls" },
        { label: "section", key: "sec" },
        { label: "subject", key: "subjects" },
        "actions",
      ],

      classesOptions: [],
      teachingList: [],
      teachingClasses: [],
      newTeachingList: [],
      gridData: [],
      // teachingClassObj: {
      //   cID: 0,
      //   sectionName: "",
      //   subjects: 0,
      // },
      teachingClassObj: {
        tID: this.$route.params.id,
        clsID: 0,
        sections: [],
        subjects: [],
        campusID: this.$store.state.userData.cId,
      },
      checkvalue: {},
      fphoneerror: false,
      mphoneerror: false,
      phoneerror: false,
      emerPhoneerror: false,
      sPhoneerror: false,
      fileProfile: "",
      vueTelOptions: { placeholder: "Enter contact number" },
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      emerOpt: { placeholder: "Enter emergency contact" },
      subjects: [],
      docLoading: false,
      mediaLoaded: false,
      salarySlipLoading: false,
      cvLoading: false,
      campuses: [],
      departments: [],
      depLoading: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      statusOptions: [
        { text: "Cleared", value: "cleared" },
        { text: "Not Cleared", value: "not cleared" },
      ],
      interObj: [],
      streamOptions: [],
      approveObj: [],
      rights: {},
      disableFields: false,
      evalQues: [],
      evalResp: [],
      payOptions: ["Cash Salary", "Bank Transfer", "Cheque Salary"],
      qualificationOptions: [...DEFAULT_QUALIFICATION_OPTIONS],
      qualifications: [],
      certificates: [],
      designations: [],
      designationSetting: null,
      showDesignationField: false,
    };
  },
  //   mounted() {
  //     this.$refs.wizard.activateAll();
  //   },
  created() {
    let rights = this.$store.state.rights["applicants"];

    if (!rights) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = rights;
      // console.log(this.rights);
      this.$route.params.id = parseInt(this.$route.params.id);
      if (isNaN(this.$route.params.id)) {
        this.$route.params.id = 0;
      }
      if (
        (this.$route.params.id !== 0 &&
          (this.rights.edit ||
            this.rights.interviewInfo ||
            this.rights.approve)) ||
        (this.$route.params.id == 0 && this.rights.add)
      ) {
        if (this.$route.params.id !== 0) {
          this.LoadData(this.$route.params.id);
          if (
            this.reportDomain == "myskoolhpgs" &&
            !this.rights.edit &&
            (this.rights.interviewInfo || this.rights.approve)
          ) {
            this.disableFields = true;
          }
        } else if (this.reportDomain == "myskoolhpgs") {
          this.LoadDep(this.$store.state.userData.cId);
          this.LoadInfo(this.$store.state.userData.cId);
        } else if (this.isMyskoolIuss) {
          this.LoadDep(this.myObj.staff.campusID);
          this.LoadInfo(this.myObj.staff.campusID);
          this.initializeIussQualificationRows();
        }
        if (this.showCampusField) {
          this.LoadCampuses();
        } else {
          this.LoadInfo(this.$store.state.userData.cId);
        }

        this.loadDesignationSettings();
        if (!this.isMyskoolIuss) {
          this.LoadStreams();
        }
        if (this.isMyskoolIuss) {
          this.LoadQualifications();
        }
        this.LoadEval();
        setTimeout(() => {
          this.sPhoneerror = false;
        }, 300);
      } else {
        this.$router.replace({
          name: "misc-not-authorized",
        });
      }
    }
  },
  computed: {
    ...mapGetters({ campusID: "campusID" }),

    isMyskoolIuss() {
      return this.reportDomain === "myskooliuss";
    },

    isMyskoolOrIuss() {
      return (
        this.reportDomain === "myskool" || this.reportDomain === "myskooliuss"
      );
    },

    pakistanProvinces() {
      return [
        "Punjab",
        "Sindh",
        "Khyber Pakhtunkhwa",
        "Balochistan",
        "Islamabad Capital Territory",
        "Gilgit-Baltistan",
        "Azad Jammu & Kashmir",
      ];
    },

    showCampusField() {
      return this.isMyskoolIuss || this.reportDomain === "myskoolhpgs";
    },

    profilePicturePreview() {
      const src = this.plus || this.myObj.staff.picture;
      if (!src) return "";
      if (String(src).startsWith("blob:")) return src;
      return getMediaPreviewUrl(src, "Image");
    },

    designationOptions() {
      const depId =
        Number(this.myObj.staff && this.myObj.staff.departmentID) || 0;
      if (!depId) return [];
      return (this.designations || []).filter((item) => {
        const itemDepId = Number(item.departmentID) || 0;
        return itemDepId === depId;
      });
    },
  },
  methods: {
    ...mapActions({ getDepartment: "getDepartment" }),
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getDocumentTypeLabel,

    setDesignation() {
      console.log("Selected designation:", this.myObj.staff.designation);
      this.CheckDesignation();
    },

    onDepartmentChange() {
      if (this.myObj.staff.designation) {
        const stillValid = this.designationOptions.some(
          (d) => d.name === this.myObj.staff.designation
        );
        if (!stillValid) this.myObj.staff.designation = "";
      }
      this.CheckDep();
    },

    normalizeDesignations(rawValue) {
      const toOption = (item, index) => {
        if (typeof item === "string") {
          return {
            id: index + 1,
            name: item.trim(),
            departmentID: 0,
          };
        }
        return {
          id: index + 1,
          name: String(item.name || "").trim(),
          departmentID: Number(item.departmentID) || 0,
        };
      };

      if (!rawValue) return [];

      if (typeof rawValue === "string" && rawValue.trim().startsWith("[")) {
        try {
          const parsed = JSON.parse(rawValue);
          if (Array.isArray(parsed)) {
            return parsed
              .map((item, index) => toOption(item, index))
              .filter((item) => item.name);
          }
        } catch (e) {
          // fall through
        }
      }

      if (typeof rawValue === "string") {
        return rawValue
          .split(",")
          .map((name) => name.trim())
          .filter((name) => name)
          .map((name, index) => ({
            id: index + 1,
            name,
            departmentID: 0,
          }));
      }

      if (Array.isArray(rawValue)) {
        return rawValue
          .map((item, index) => toOption(item, index))
          .filter((item) => item.name);
      }

      return [];
    },

    async loadDesignationSettings() {
      try {
        const response = await this.post({
          url: `${this.$store.state.domain}Settings/getSettingsAll?db=${this.$store.state.userData.db}`,
          body: ["staff-designations"],
          context: this,
          token: this.$store.state.userData.token,
          subjects: true,
        });

        let settingsArray = [];
        if (
          response &&
          response.status === "success" &&
          response.data &&
          Array.isArray(response.data)
        ) {
          settingsArray = response.data;
        } else if (Array.isArray(response)) {
          settingsArray = response;
        } else {
          console.warn("Unexpected response format for settings:", response);
          return;
        }

        this.designationSetting = settingsArray.find(
          (setting) => setting.key === "staff-designations"
        );

        if (this.designationSetting && this.designationSetting.value) {
          this.designations = this.normalizeDesignations(
            this.designationSetting.value
          );
        } else {
          this.designations = [];
        }

        this.showDesignationField = this.designations.length > 0;
      } catch (error) {
        console.error("Error loading designation settings:", error);
        this.showDesignationField = false;
        this.designations = [];
      }
    },

    async LoadEval() {
      var obj = {
        url:
          this.$store.state.domain +
          "DropDownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=interviewQuestions",
        token: this.$store.state.userData.token,
      };
      this.evalQues = await this.get(obj);

      var obj = {
        url:
          this.$store.state.domain +
          "DropDownList/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&category=interviewResponses",
        token: this.$store.state.userData.token,
      };
      this.evalResp = await this.get(obj);
    },
    openEval() {
      console.log(this.evalResp, this.evalQues);
    },

    checkEval(e, item) {
      if (e && item.evaluationData.length == 0) {
        item.evaluationData = this.evalQues.map((el) => ({
          id: 0,
          tID: this.$route.params.id,
          interviewID: item.interviews.id,
          questionID: el.id,
          responseID: 0,
          meta_question: el.title,
          meta_response: null,
          campusID: this.myObj.staff.campusID,
        }));
      }
      // console.log(item);
    },
    AddValue() {
      this.interObj.push({
        interviews: {
          id: 0,
          staffID: this.$route.params.id,
          date: new Date().toJSON().split("T")[0],
          status: "",
          interviewedBy: "",
          note: "",
          recommendedSalary: 0,
          duration: "",
          includeEvaluation: false,
        },
        evaluationData: this.evalQues.map((el) => ({
          id: 0,
          tID: this.$route.params.id,
          interviewID: 0,
          questionID: el.id,
          responseID: 0,
          meta_question: el.title,
          meta_response: null,
          campusID: this.myObj.staff.campusID,
        })),
      });
      // console.log(this.interObj);

      // this.interObj.push({
      //   id: 0,
      //   staffID: this.$route.params.id,
      //   date: null,
      //   status: "",
      //   interviewedBy: "",
      //   note: "",
      //   recommendedSalary: 0,
      //   duration: "",
      //   includeEvaluation: false,
      // });
    },
    async removeValue(id, ind) {
      if (id > 0) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "StaffInterviews/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.interObj.splice(ind, 1);
        }
      } else this.interObj.splice(ind, 1);
    },
    async approve() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "Do you want to approve this applicant?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.approveObj.push({
          id: 0,
          staffID: this.$route.params.id,
          name: this.$store.state.loggedUser.name,
          date: new Date().toJSON(),
          approvedBy: this.$store.state.userData.userID,
          approvedBy_Meta: "",
        });
      }
    },
    buildDocumentEntry(url, originalName, index) {
      const name = originalName || getDocumentDisplayName(url, index);
      return {
        url,
        name,
        typeLabel: getDocumentTypeLabel(url, name),
      };
    },
    getDocPreviewUrl(url) {
      return getMediaPreviewUrl(url, "Image");
    },
    getDocOpenUrl(url) {
      return isImageUrl(url) ? getMediaPreviewUrl(url, "Image") : url;
    },
    isImageDoc(url) {
      return isImageUrl(url);
    },
    onDocPreviewError(event, url) {
      if (!url) return;
      handleDrivePreviewError(event, url, "image");
    },
    onPicturePreviewError(event) {
      handleDrivePreviewError(
        event,
        this.plus || this.myObj.staff.picture,
        "image"
      );
    },
    syncDocumentField() {
      this.myObj.staff.documents = this.documentEntries
        .map((entry) => entry.url)
        .join(",");
    },
    deleteDocument(index) {
      this.documentEntries.splice(index, 1);
      this.syncDocumentField();
    },
    async uploadDocument() {
      let docs = this.$refs.cvDoc.files;
      if (docs.length != 0) {
        this.uploading = true;
        try {
          const uploaded = await uploadToMySkool(docs);
          uploaded.forEach((el) => {
            const url = getUploadPath(el);
            if (!url) return;
            this.documentEntries.push(
              this.buildDocumentEntry(
                url,
                el.originalname || el.originalName,
                this.documentEntries.length
              )
            );
          });
          this.syncDocumentField();
        } catch (err) {
          console.log(err);
        } finally {
          this.uploading = false;
        }
      }
    },
    deleteLogo() {
      if (this.plus && String(this.plus).startsWith("blob:")) {
        URL.revokeObjectURL(this.plus);
      }
      this.myObj.staff.picture = null;
      this.plus = "";
      this.logoloading = false;
      if (this.$refs.fileProfile) {
        this.$refs.fileProfile.value = null;
      }
    },
    async selectlogo() {
      const file = this.$refs.fileProfile.files[0];
      if (!file) return;

      if (this.plus && String(this.plus).startsWith("blob:")) {
        URL.revokeObjectURL(this.plus);
      }

      this.fileProfile = file;
      this.logoloading = true;
      const localPreview = URL.createObjectURL(file);
      this.plus = localPreview;

      try {
        const uploaded = await uploadToMySkool([file]);
        const fn1 = getUploadPath(uploaded[0]);
        URL.revokeObjectURL(localPreview);
        this.plus = fn1;
        this.myObj.staff.picture = fn1;
        this.logoloading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.plus = "";
        this.myObj.staff.picture = null;
        this.logoloading = false;
        console.log(err);
      } finally {
        if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
      }
    },
    removeCV() {
      this.myObj.cv = null;
      this.mediaLoaded = false;
      this.$refs.cvDoc.files = null;
    },
    async addCV() {
      let doc = this.$refs.cvDoc.files[0];
      if (!doc) return;
      this.mediaLoaded = false;
      this.docLoading = true;
      try {
        const uploaded = await uploadToMySkool([doc]);
        this.myObj.cv = getUploadPath(uploaded[0]);
        this.mediaLoaded = true;
      } catch (err) {
        console.log(err);
      } finally {
        this.docLoading = false;
      }
    },
    async uploadSalarySlip() {
      const input = this.$refs.salarySlipInput;
      const file = input && input.files && input.files[0];
      if (!file) return;
      this.salarySlipLoading = true;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.myObj.staff.salarySlip = getUploadPath(uploaded[0]) || "";
      } catch (err) {
        console.log(err);
        this.$bvToast.toast("Failed to upload salary slip.", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.salarySlipLoading = false;
        if (input) input.value = "";
      }
    },
    removeSalarySlip() {
      this.myObj.staff.salarySlip = "";
      if (this.$refs.salarySlipInput) this.$refs.salarySlipInput.value = "";
    },
    async uploadStaffCv() {
      const input = this.$refs.cvFileInput;
      const file = input && input.files && input.files[0];
      if (!file) return;
      this.cvLoading = true;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.myObj.staff.cv = getUploadPath(uploaded[0]) || "";
      } catch (err) {
        console.log(err);
        this.$bvToast.toast("Failed to upload CV.", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.cvLoading = false;
        if (input) input.value = "";
      }
    },
    removeStaffCv() {
      this.myObj.staff.cv = "";
      if (this.$refs.cvFileInput) this.$refs.cvFileInput.value = "";
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.staff.name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckFName() {
      var elem = this.$refs["fname"];
      if (this.myObj.staff.father_name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    createEmptyQualification() {
      return {
        id: 0,
        degree: "",
        subject: "",
        institute: "",
        year: "",
        grade: "",
      };
    },
    createEmptyCertificate() {
      return {
        id: 0,
        name: "",
        institute: "",
        year: "",
      };
    },
    initializeIussQualificationRows() {
      if (!this.qualifications.length) {
        this.qualifications = [this.createEmptyQualification()];
      }
    },
    hydrateIussQualificationsAndCertificates() {
      const staff = this.myObj.staff || {};
      let quals = Array.isArray(this.myObj.qualifications)
        ? this.myObj.qualifications
        : [];
      let certs = Array.isArray(this.myObj.certificates)
        ? this.myObj.certificates
        : [];

      quals = quals.map((q) => ({
        id: q.id || 0,
        degree: q.degree || "",
        subject: q.subject || "",
        institute: q.institute || "",
        year: q.year ? String(q.year) : "",
        grade: q.grade || "",
      }));
      certs = certs.map((c) => ({
        id: c.id || 0,
        name: c.name || "",
        institute: c.institute || "",
        year: c.year ? String(c.year) : "",
      }));

      if (!quals.length && staff.qualification) {
        quals.push({
          id: 0,
          degree: staff.qualification,
          subject: "",
          institute: staff.note || "",
          year: "",
          grade: "",
        });
      }
      if (!certs.length && staff.certificate) {
        certs.push({
          id: 0,
          name: staff.certificate,
          institute: "",
          year: "",
        });
      }

      this.qualifications = quals.length
        ? quals
        : [this.createEmptyQualification()];
      this.certificates = certs;
    },
    addQualification() {
      this.qualifications.push(this.createEmptyQualification());
    },
    removeQualification(index) {
      if (this.qualifications.length <= 1) return;
      this.qualifications.splice(index, 1);
      this.CheckQualification();
    },
    addCertificate() {
      this.certificates.push(this.createEmptyCertificate());
    },
    removeCertificate(index) {
      this.certificates.splice(index, 1);
    },
    getQualificationsForSave() {
      return this.qualifications
        .filter((q) => q.degree && String(q.degree).trim())
        .map((q) => ({
          id: q.id || 0,
          degree: String(q.degree).trim(),
          subject: String(q.subject || "").trim(),
          institute: String(q.institute || "").trim(),
          year: String(q.year || "").trim(),
          grade: String(q.grade || "").trim(),
        }));
    },
    getCertificatesForSave() {
      return this.certificates
        .filter((c) => c.name && String(c.name).trim())
        .map((c) => ({
          id: c.id || 0,
          name: String(c.name).trim(),
          institute: String(c.institute || "").trim(),
          year: String(c.year || "").trim(),
        }));
    },
    syncStaffQualificationFromList() {
      const list = this.getQualificationsForSave();
      this.myObj.staff.qualification = list.length ? list[0].degree : "";
    },
    buildApplicantSaveBody(interData) {
      if (this.isMyskoolIuss) {
        this.syncStaffQualificationFromList();
      }
      this.myObj.staff.previousSalary =
        parseInt(this.myObj.staff.previousSalary, 10) || 0;
      this.myObj.staff.expectedSalary =
        parseInt(this.myObj.staff.expectedSalary, 10) || 0;
      const staff = {
        ...this.myObj.staff,
        streamID: streamIdForApi(this.myObj.staff.streamID),
      };
      const body = {
        staff,
        subjectIDs: this.myObj.subjectIDs,
        interviews: interData,
        approvals: this.approveObj,
      };
      if (this.isMyskoolIuss) {
        body.qualifications = this.getQualificationsForSave();
        body.certificates = this.getCertificatesForSave();
      }
      return body;
    },
    CheckQualification() {
      if (this.isMyskoolIuss) {
        const ref = this.$refs.qua;
        const elem = Array.isArray(ref) ? ref[0] : ref;
        const valid = this.qualifications.some(
          (q) => q.degree && String(q.degree).trim()
        );
        if (elem) {
          elem.state = valid;
        }
        return valid;
      }
      var elem = this.$refs["qua"];
      if (this.myObj.staff.qualification == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDesignation() {
      var elem = this.$refs["design"];
      if (this.myObj.staff.designation == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckFContact() {
      // console.log(this.myObj.contact_father);
      // console.log(this.myObj.contact_father.length);
      if (this.myObj.contact_father.length == 12) {
        this.fphoneerror = false;
        return true;
      } else {
        this.fphoneerror = true;
        return false;
      }
    },
    CheckMContact() {
      // console.log(this.myObj.contact_mother);
      // console.log(this.myObj.contact_mother.length);
      if (this.myObj.contact_mother.length == 12) {
        this.mphoneerror = false;
        return true;
      } else {
        this.mphoneerror = true;
        return false;
      }
    },
    CheckContact() {
      // console.log(this.myObj.contact_student);
      // console.log(this.myObj.contact_student.length);
      if (this.myObj.staff.contact_number.length == 12) {
        this.phoneerror = false;
        return true;
      } else {
        this.phoneerror = true;
        return false;
      }
    },
    CheckSContact(s, e) {
      // console.log(this.myObj.contact_number);
      // console.log(this.myObj.contact_student.length);
      // if (this.myObj.staff.contact_number.length == 12) {
      //   this.sPhoneerror = false;
      //   return true;
      // } else {
      //   this.sPhoneerror = true;
      //   return false;
      // }
      if (e.valid) {
        this.sPhoneerror = false;
        this.myObj.staff.contact_number = e.number;
      } else {
        this.sPhoneerror = true;
      }
    },

    CheckEmerName() {
      var elem = this.$refs["emerName"];
      if (
        this.myObj.staff.emergency_name == null ||
        this.myObj.staff.emergency_name == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerRelation() {
      var elem = this.$refs["emerRel"];
      if (
        this.myObj.staff.emergency_relationship == null ||
        this.myObj.staff.emergency_relationship == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerContact() {
      if (this.myObj.staff.emergency_contact.length == 12) {
        console.log(this.myObj.staff.emergency_contact.length);
        this.emerPhoneerror = false;
        return true;
      } else {
        this.emerPhoneerror = true;
        return false;
      }
    },
    CheckSalary() {
      const regex = /^(\d*([.,](?=\d{3}))?\d+)+((?!\2)[.,]\d\d)?$/;
      var elem = this.$refs["salary"];
      if (regex.test(this.myObj.staff.expectedSalary)) {
        if (this.myObj.staff.expectedSalary == 0) {
          return (elem.state = false);
        } else {
          this.myObj.staff.expectedSalary = parseInt(
            this.myObj.staff.expectedSalary
          );
          return (elem.state = true);
        }
      } else {
        return (elem.state = false);
      }
    },
    CheckPreviousSalary() {
      if (!this.isMyskoolIuss) return true;
      var elem = this.$refs["prevSalary"];
      const val = parseInt(this.myObj.staff.previousSalary, 10);
      if (!val || val <= 0) {
        if (elem) elem.state = false;
        return false;
      }
      this.myObj.staff.previousSalary = val;
      if (elem) elem.state = true;
      return true;
    },
    CheckAvailability() {
      if (!this.isMyskoolIuss) return true;
      var elem = this.$refs["avail"];
      if (!this.myObj.staff.availibility) {
        if (elem) elem.state = false;
        return false;
      }
      if (elem) elem.state = true;
      return true;
    },
    CheckCampus() {
      if (!this.showCampusField) return true;
      var elem = this.$refs["camp"];
      if (!this.myObj.staff.campusID) {
        if (elem) elem.state = false;
        return false;
      }
      if (elem) elem.state = true;
      return true;
    },
    CheckDep() {
      if (this.showCampusField) {
        var elem = this.$refs["dep"];
        if (this.myObj.staff.departmentID == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckCnic() {
      var elem = this.$refs["cnic"];
      if (!this.myObj.staff.cnic) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDate() {
      var elem = this.$refs["dob"];
      if (!this.myObj.staff.date_of_birth) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckRegDate() {
      var elem = this.$refs["reg_date"];
      if (!this.myObj.staff.registrationDate) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckGender() {
      var elem = this.$refs["gender"];
      if (this.myObj.staff.gender == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckAddress() {
      var elem = this.$refs["address"];
      if (this.myObj.staff.address_current == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckInterview() {
      let state = true;
      if (
        this.reportDomain == "myskoolhpgs" ? this.rights.interviewInfo : true
      ) {
        this.interObj.forEach((el) => {
          let x = parseInt(el.interviews.recommendedSalary);
          if (
            !el.interviews.date ||
            !el.interviews.interviewedBy ||
            !el.interviews.status ||
            isNaN(x) ||
            x < 0
          ) {
            state = false;
          } else el.interviews.recommendedSalary = x;
        });
      } else {
        this.interObj.forEach((el) => {
          let x = parseInt(el.interviews.recommendedSalary);
          if (isNaN(x) || x < 0) {
            el.interviews.recommendedSalary = 0;
          } else el.interviews.recommendedSalary = x;
        });
      }
      return state;
    },
    CheckTcID() {
      var elem = this.$refs["tcID"];
      if (this.teachingClassObj.clsID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTSection() {
      // console.log(this.teachingClassObj.sections.length);
      var elem = this.$refs["tSection"];
      if (this.teachingClassObj.sections.length === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTSubject() {
      // console.log(this.teachingClassObj.subjects.length);
      var elem = this.$refs["sub"];
      if (this.myObj.subjectIDs.length === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    FillSections() {
      console.log(this.teachingClassObj.clsID);
      // this.teachingClassObj.sections = [];
      this.classes.forEach((elem) => {
        if (elem.cls.id === this.teachingClassObj.clsID) {
          if (elem.sections.length != 0) {
            console.log("not null");
            this.admittedSections = elem.sections;
          } else {
            console.log("null");
            this.admittedSections = [];
          }
        }
      });
      console.log("Thisis", this.admittedSections);
    },
    async assign() {
      this.teachingClassObj.tID = parseInt(this.$route.params.id);
      console.log(this.teachingClassObj);
      this.CheckTcID();
      this.CheckTSubject();
      this.CheckTSection();
      if (
        this.CheckTcID() == false ||
        this.CheckTSubject() == false ||
        this.CheckTSection() == false
      ) {
        return this.$bvToast.toast("Please enter all the required fields.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } else {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "TeacherClasses/SaveData?db=" +
            this.$store.state.userData.db,
          body: this.teachingClassObj,
          message: "Classes assigned successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.LoadTeachingClasses();
          this.teachingClassObj = {
            tID: this.$route.params.id,
            clsID: 0,
            sections: [],
            subjects: [],
            campusID: this.$store.state.userData.cId,
          };
        }
      }
    },
    FillSectionsCurrent() {
      //return console.log(this.classes);
      this.classes.forEach((elem) => {
        if (elem.id == this.myObj.class_current) {
          this.currentSections = elem.sections.split(",");
        }
      });
      console.log("Thisis", this.admittedSections);
    },
    async LoadData(id) {
      // "staff/LoadSelectedApplicantNew?db=" +
      var obj = {
        url:
          this.$store.state.domain +
          "staff/LoadSelectedApplicantWithInterview?db=" +
          this.$store.state.userData.db +
          "&id=" +
          id,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      let res = await this.get(obj);
      // console.log(res);
      if (!Array.isArray(res)) {
        this.myObj = res.data;
        // streamID 0 / missing => All Streams (sentinel option id)
        this.normalizeStaffStreamID();
        // this.evalResp = res.responsesData;
        // console.log(this.myObj);

        this.interObj = this.myObj.interviews;
        this.approveObj = this.myObj.approvals;

        if (this.showCampusField) {
          this.LoadDep(this.myObj.staff.campusID);
          this.LoadInfo(this.myObj.staff.campusID);
        }
        if (
          this.myObj.staff.picture !== null &&
          this.myObj.staff.picture !== ""
        ) {
          this.plus = this.myObj.staff.picture;
          this.logoloading = "loaded";
        }
        if (
          this.myObj.staff.documents !== null &&
          this.myObj.staff.documents !== ""
        ) {
          this.documentEntries = this.myObj.staff.documents
            .split(",")
            .filter(Boolean)
            .map((url, index) => this.buildDocumentEntry(url, null, index));
        }
        if (this.isMyskoolIuss) {
          this.hydrateIussQualificationsAndCertificates();
        }
      } else {
        this.$router.replace({ name: "applicants" }).then(() => {
          this.$bvToast.toast("No record found!", {
            title: this.$t("Error!"),
            variant: "danger",
            solid: true,
          });
        });
      }
    },
    async LoadInfo(id) {
      this.dataloading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          id,
        token: this.$store.state.userData.token,
      };
      this.subjects = await this.get(obj);

      // console.log("subject", this.subjects);
      this.dataloading = false;
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },
    async LoadStreams() {
      var obj = {
        url:
          this.$store.state.domain +
          "Stream/LoadSelectedData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      try {
        let list = await this.get(obj);
        if (!Array.isArray(list) && list && Array.isArray(list.data)) {
          list = list.data;
        }
        this.streamOptions = buildStreamOptions(list, this.$t("All Streams"));
      } catch (error) {
        console.error("Error loading stream selected data:", error);
        this.streamOptions = buildStreamOptions([], this.$t("All Streams"));
      }
      // Re-apply after options load so the sentinel option binds correctly
      this.normalizeStaffStreamID();
    },
    normalizeStaffStreamID() {
      if (!this.myObj || !this.myObj.staff) return;
      this.$set(
        this.myObj.staff,
        "streamID",
        normalizeStreamIdForUi(this.myObj.staff.streamID)
      );
    },
    async LoadDep(id) {
      this.depLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "StaffDepartments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          id,
        token: this.$store.state.userData.token,
      };
      this.departments = await this.get(obj);
      this.depLoading = false;
    },
    setData() {
      this.myObj.subjectIDs = [];
      this.LoadInfo(this.myObj.staff.campusID);
      if (this.isMyskoolIuss) {
        this.LoadDep(this.myObj.staff.campusID);
      }
    },

    parseQualificationsApiPayload(payload) {
      if (payload == null || payload === "") return [];
      if (typeof payload === "string") {
        return [
          ...new Set(
            payload
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          ),
        ];
      }
      if (Array.isArray(payload)) {
        return [
          ...new Set(payload.map((s) => String(s).trim()).filter(Boolean)),
        ];
      }
      if (typeof payload === "object") {
        if (Array.isArray(payload.items)) {
          return [
            ...new Set(
              payload.items.map((s) => String(s).trim()).filter(Boolean)
            ),
          ];
        }
        if (payload.value != null) {
          return this.parseQualificationsApiPayload(payload.value);
        }
        if (payload.data != null) {
          return this.parseQualificationsApiPayload(payload.data);
        }
        if (payload.status === "success" && payload.data != null) {
          return this.parseQualificationsApiPayload(payload.data);
        }
      }
      return [];
    },
    async LoadQualifications() {
      try {
        const url =
          this.$store.state.domain +
          "Settings/GetQualifications?db=" +
          encodeURIComponent(this.$store.state.userData.db) +
          "&cID=" +
          this.$store.state.userData.cId;
        const res = await this.get({
          url,
          token: this.$store.state.userData.token,
        });
        const list = this.parseQualificationsApiPayload(res);
        const presetSet = new Set(DEFAULT_QUALIFICATION_OPTIONS);
        const extras = list.filter((x) => x && !presetSet.has(x));
        extras.sort((a, b) =>
          a.localeCompare(b, undefined, { sensitivity: "base" })
        );
        this.qualificationOptions = [
          ...DEFAULT_QUALIFICATION_OPTIONS,
          ...extras,
        ];
      } catch (error) {
        console.error("Error loading qualifications:", error);
      }
    },

    EditTeaching(item) {
      console.log(item);
      this.teachingClassObj = {
        tID: this.$route.params.id,
        clsID: 0,
        sections: [],
        subjects: [],
        campusID: this.$store.state.userData.cId,
      };
      this.teachingClassObj.clsID = item.clsID;
      item.subjects.forEach((el) => this.teachingClassObj.subjects.push(el.id));
      this.FillSections();
      this.teachingClassObj.sections = item.sections;
    },
    async DeleteTeaching(item) {
      console.log(item);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "TeacherClasses/Remove?db=" +
            this.$store.state.userData.db,
          body: item,
          message: "Teaching classes removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        console.log(status);
        if (status) this.LoadTeachingClasses();
      }
    },
    async formSubmitted(txt) {
      this.CheckName();
      this.CheckFName();
      // this.CheckSContact();
      this.CheckDesignation();
      this.CheckQualification();
      // this.CheckTSubject();
      this.CheckSalary();
      this.CheckDep();
      this.CheckCnic();
      this.CheckDate();
      this.CheckRegDate();
      this.CheckGender();
      this.CheckAddress();
      if (this.isMyskoolIuss) {
        this.CheckCampus();
        this.CheckPreviousSalary();
        this.CheckAvailability();
      }
      if (this.myObj.staff.contact_number == "") this.sPhoneerror = true;

      const iussInvalid =
        this.isMyskoolIuss &&
        (this.CheckCampus() == false ||
          this.CheckPreviousSalary() == false ||
          this.CheckAvailability() == false);

      if (
        this.CheckName() == false ||
        this.CheckFName() == false ||
        // this.CheckSContact() == false ||
        this.myObj.staff.contact_number == "" ||
        this.sPhoneerror ||
        this.CheckDesignation() == false ||
        this.CheckQualification() == false ||
        // this.CheckTSubject() == false ||
        this.CheckSalary() == false ||
        this.CheckDep() == false ||
        this.CheckCnic() == false ||
        this.CheckDate() == false ||
        this.CheckRegDate() == false ||
        this.CheckGender() == false ||
        this.CheckAddress() == false ||
        this.CheckInterview() == false ||
        iussInvalid
      ) {
        return this.$bvToast.toast("Please fill the form correctly!", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } else {
        if (txt == "approve") {
          this.saveFinal();
          // this.$bvModal.show("modal-login");
        } else {
          this.request = true;

          if (this.myObj.staff.date_of_birth == "") {
            this.myObj.staff.date_of_birth = null;
          }
          if (this.myObj.staff.approvalDate == "") {
            this.myObj.staff.approvalDate = null;
          }
          if (this.myObj.staff.appointedOn == "") {
            this.myObj.staff.appointedOn = null;
          }
          this.myObj.staff.leaves_allowed_from = this.myObj.staff.appointedOn;

          if (!this.myObj.staff.empCode) {
            this.myObj.staff.empCode = 0;
          }

          if (!this.myObj.staff.tag) {
            this.myObj.staff.tag = "Physical";
          }

          if (
            [null, "", "pending"].includes(this.myObj.staff.applicantStatus) &&
            this.interObj.length > 0
          ) {
            this.myObj.staff.applicantStatus = "in progress";
          }

          let interData = this.interObj.map((el) => {
            let obj = { interviews: el.interviews, evaluationData: [] };
            if (
              el.interviews.includeEvaluation &&
              el.evaluationData.find((el) => el.responseID > 0)
            ) {
              obj.evaluationData = el.evaluationData;
            } else {
              obj.interviews.includeEvaluation = false;
              el.interviews.includeEvaluation = false;
            }
            return obj;
          });
          // console.log(interData);

          // "staff/SaveApplicantNew?db=" +
          const userID =
            this.$store.state.userData.userID ||
            this.$store.state.userData.userLinkID ||
            this.$store.state.userData.localID ||
            0;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "staff/SaveApplicantWithInterview?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              userID,
            body: this.buildApplicantSaveBody(interData),
            message: "Application submitted successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.$router.go(-1);
          }
        }
      }
    },
    CheckFinal() {
      var elem = this.$refs["final_sal"];
      let x = parseInt(this.finalSalary);
      if (isNaN(x) || x <= 0) {
        return (elem.state = false);
      } else {
        this.finalSalary = x;
        return (elem.state = true);
      }
    },
    CheckApprove() {
      var elem = this.$refs["approve_date"];
      if (!this.myObj.staff.approvalDate) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveFinal() {
      if (this.CheckFinal() == true && this.CheckApprove() == true) {
        this.request = true;

        if (this.myObj.staff.date_of_birth == "") {
          this.myObj.staff.date_of_birth = null;
        }
        if (this.myObj.staff.appointedOn == "") {
          this.myObj.staff.appointedOn = null;
        }

        if (
          this.reportDomain == "myskoolhpgs" &&
          this.myObj.staff.appointedOn
        ) {
          let appointedDate = new Date(this.myObj.staff.appointedOn);
          let leaveAllowedDate = new Date(
            appointedDate.setMonth(appointedDate.getMonth() + 3)
          );
          this.myObj.staff.leaves_allowed_from = leaveAllowedDate
            .toJSON()
            .split("T")[0];
        } else {
          this.myObj.staff.leaves_allowed_from = this.myObj.staff.appointedOn;
        }

        if (!this.myObj.staff.empCode) {
          this.myObj.staff.empCode = 0;
        }

        this.myObj.staff.tag = "Physical";

        this.myObj.staff.basicSalary = this.finalSalary;
        this.myObj.staff.totalSalary = this.finalSalary;
        this.myObj.staff.status = "present";
        this.myObj.staff.applicantStatus = "approved";
        // this.myObj.staff.appointedOn = new Date().toJSON();

        this.approveObj.push({
          id: 0,
          staffID: this.$route.params.id,
          date: new Date().toJSON(),
          approvedBy: this.$store.state.userData.userID,
          approvedBy_Meta: "",
        });

        let interData = this.interObj.map((el) => {
          let obj = { interviews: el.interviews, evaluationData: [] };
          if (
            el.interviews.includeEvaluation &&
            el.evaluationData.find((el) => el.responseID > 0)
          ) {
            obj.evaluationData = el.evaluationData;
          } else {
            obj.interviews.includeEvaluation = false;
            el.interviews.includeEvaluation = false;
          }
          return obj;
        });
        // console.log(interData);

        // "staff/SaveApplicantNew?db=" +
        const userID =
          this.$store.state.userData.userID ||
          this.$store.state.userData.userLinkID ||
          this.$store.state.userData.localID ||
          0;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "staff/SaveApplicantWithInterview?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            userID,
          body: this.buildApplicantSaveBody(interData),
          message: "Application submitted successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        if (status) {
          this.$router.go(-1);
        }
      }
    },
  },
};
</script>
<style>
.heading {
  padding: 0;
  margin: 2.171303074670571vw 0;
  /* text-shadow: -4px 0 5px white, 0 4px 5px white, 4px 0 5px white,
        0 -4px 5px white; */
}
.input-form {
  margin: 0 70px;
  background: #fff;
}
#fileInput .custom-file-label {
  color: #707070;
  border: 1px dashed #33312f;
  text-align: center;
  padding: 2.5rem 1.5rem;
  width: 100%;
}
#fileInput input {
  display: none;
}
#imgInput input {
  display: none;
}
#imgInput {
  /* height: 8rem; */
  width: 50%;
}
#imgInput div {
  height: 8vw;
}
#imgInput .custom-file-label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.type {
  background-color: red;
  border-radius: 10px;
  font-size: 0.8rem;
  padding: 10px;
  color: white;
}
.filename {
  padding-left: 25px;
}
.delete {
  margin: 0 0 0 auto;
  color: red;
}
#checkbox-1 {
  margin-right: 10px !important;
}
.submit {
  background-color: #00c192;
  color: #fff;
  width: 16.5vw;
  height: 4vw;
  font-weight: bold;
  border-color: #00c192;
}
.form-file-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 20px;
}
/* #prop-det, #prop-det div {
      height: 100%;
    } */

.item-group {
  width: 50%;
  /* margin-top: 2.269399707174231vw; */
}
.inputfields,
.inputfields:focus {
  border: 1px solid #33312f;
  border-radius: 0.5856515373352855vw;
  height: 2.562225475841874vw;
  outline: none !important;
  resize: none;
}
@media only screen and (max-width: 990px) {
  .mob-setting {
    padding: 0 1rem !important;
    width: 100vw !important;
    margin: 0 auto !important;
  }
  .mobile-view {
    margin: 0 !important;
  }
  .item-group {
    margin-top: 0;
  }
  .margin-top-mobile {
    margin-top: 5vw;
  }
  .form-input-mobile-text {
    width: 92vw;
    margin: 10px auto;
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    font-size: 5.171303074670571vw;
    background-color: #f2f2f2 !important;
    border: 1px solid #33312f;
  }
  .form-input-mobile-text:focus {
    background-color: #00c192 !important;
    color: #fff !important;
  }
  .form-input-mobile-text::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(190, 190, 190);
    opacity: 1; /* Firefox */
    font-family: DINNextRoundedLTW01-Regular;
  }

  .form-input-mobile-text:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text::-ms-input-placeholder {
    /* Microsoft Edge */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text:focus::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #fff;
  }
  .form-file-input-mobile {
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #fff !important;
  }
  .custom-file-label {
    border-radius: 2.8301610541727673vw !important;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #000 !important;
    height: 40vw;
    border: 1px solid #33312f;
  }
  .submit {
    width: 50vw;
    height: 10vw;
  }
  .filename {
    font-size: 3vw;
  }
  .shadowHead {
    font-size: 8vw !important;
  }
  #imgInput div {
    height: 29vw !important;
  }
  .item-group {
    height: 30vw !important;
  }
}

@media only screen and (min-width: 1366px) {
  .submit {
    width: 15.5vw;
    height: 7.8vh;
  }
}
@media only screen and (min-width: 1440px) {
  .submit {
    width: 14.7vw;
    height: 6.7vh;
  }
}
@media only screen and (min-width: 1536px) {
  .submit {
    width: 13.8vw;
    height: 6.9vh;
  }
}
@media only screen and (min-width: 1920px) {
  .submit {
    width: 11vw;
    height: 5.5vh;
  }
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
<style scoped>
.file-uploader {
  position: relative;
  border: 1px solid #000;
  width: 100%;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
  font-family: "Helvetica", sans-serif;
  height: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.file_upload {
  opacity: 0;

  /* IE 8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";

  /* IE 5-7 */
  filter: alpha(opacity=0);

  /* Netscape or and older firefox browsers */
  -moz-opacity: 0;

  /* older Safari browsers */
  -khtml-opacity: 0;

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.file-type {
  background-color: #e62e2d;
  font-family: "Helvetica", sans-serif;
  color: white;
  border-radius: 10px;
  margin-right: 15px;
  height: 50px;
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.file-name {
  font-family: "Helvetica", sans-serif;
  margin: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  color: #6e6b7b;
}

.file-delete i {
  color: #e62e2d;
  font-size: 2rem;
  cursor: pointer;
}
.rcorners2 {
  border-radius: 100px;
  border: 4px solid var(--primary);
  padding: 2px;
}
.sticky {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-right: 60px;
  margin-bottom: 30px;
  /* position: fixed;
        bottom: 5%;
        z-index: 1031;  */
}

.staff-app-photo-upload {
  display: flex;
  justify-content: center;
  width: 100%;
}

.staff-app-photo-frame {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.staff-app-photo-frame--loaded {
  position: relative;
}

.staff-app-photo-img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  cursor: pointer;
  display: block;
}

.staff-app-photo-upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 100px;
  z-index: 3;
}

.staff-app-photo-delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.25rem 0.4rem;
}

.doc-list-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 10px;
  flex-shrink: 0;
}
</style>
<style lang="scss">
@import "~@core/scss/base/bootstrap-extended/include";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.iuss-entry-section {
  .iuss-entry-head {
    border-bottom: 1px solid #ebe9f1;
    padding-bottom: 0.5rem;
  }

  .iuss-entry-row {
    padding: 0.65rem 0;
    border-bottom: 1px solid #f3f2f7;
  }

  .iuss-entry-row:last-child {
    border-bottom: none;
  }

  .iuss-entry-row-inner {
    align-items: flex-end;

    > [class*="col"] {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }

  .iuss-entry-field {
    width: 100%;
    margin-bottom: 0 !important;
  }

  .iuss-entry-select-wrap {
    width: 100%;

    .v-select {
      margin: 0;
    }

    .vs__dropdown-toggle {
      box-sizing: border-box !important;
      height: $input-height !important;
      min-height: $input-height !important;
      max-height: $input-height !important;
      padding: 0 $input-padding-x !important;
      border: $input-border-width solid $input-border-color !important;
      border-radius: $input-border-radius !important;
      background: $input-bg !important;
      display: flex;
      align-items: center;
      box-shadow: none !important;
    }

    .vs__selected-options {
      min-height: 0;
      padding: 0;
      margin: 0;
      flex-wrap: nowrap;
      align-items: center;
    }

    .vs__selected {
      margin: 0 !important;
      padding: 0 !important;
      line-height: $line-height-base;
      font-size: $font-size-base;
      color: $input-color;
    }

    .vs__search {
      margin: 0;
      padding: 0;
      line-height: $line-height-base;
      font-size: $font-size-base;
    }

    .vs__actions {
      padding: 0 0 0 4px;
      align-items: center;
    }

    .vs__open-indicator {
      margin-top: 0;
      transform: scale(0.9);
    }
  }

  .iuss-entry-row .form-control {
    height: $input-height;
    padding: $input-padding-y $input-padding-x;
    line-height: $line-height-base;
    font-size: $font-size-base;
  }

  .iuss-entry-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: $input-height;
    padding-bottom: 0;
  }

  .iuss-entry-add-btn,
  .iuss-entry-remove-btn {
    width: $input-height;
    height: $input-height;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  @include media-breakpoint-down(md) {
    .iuss-entry-row {
      background: #fafafa;
      border: 1px solid #f0eff5;
      border-radius: 0.5rem;
      padding: 0.85rem 0.5rem;
      margin-bottom: 0.75rem;
      border-bottom: none;
    }

    .iuss-entry-row:last-child {
      margin-bottom: 0;
    }

    .iuss-entry-row-inner {
      align-items: stretch;

      > [class*="col-12"] {
        margin-bottom: 0.75rem;
      }

      > [class*="col-12"]:last-child {
        margin-bottom: 0;
      }
    }

    .iuss-entry-field {
      legend,
      label {
        margin-bottom: 0.35rem;
      }
    }

    .iuss-entry-actions {
      min-height: $input-height;
      justify-content: flex-end;
      align-items: flex-end;
      padding-bottom: 0;
      margin-bottom: 0 !important;
    }

    .iuss-entry-remove-btn {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
}
</style>
